import { ADDRESS_BILLING_CATEGORY, ADDRESS_SHIPPING_CATEGORY } from 'services/constants/cart';
import type { CartAddressData } from 'services/types';
import type { LocaleIso } from 'utils';
import { isPhoneRequired } from './isPhoneRequired';
import { isPickupPointAddress } from './isPickupPointAddress';

const hasValue = (value: unknown): boolean => value !== null && value !== undefined && String(value).trim().length > 0;

/** Returns whether a saved address contains all fields required by its destination type and locale. */
export function isAddressCompleteForLocale(address: CartAddressData | undefined, locale: LocaleIso): boolean {
  if (!address) {
    return false;
  }

  const isPickupPoint = isPickupPointAddress(address);
  const hasBaseFields = [address.firstName, address.lastName, address.zip, address.city, address.country].every(hasValue);

  if (!hasBaseFields || (!isPickupPoint && !hasValue(address.street))) {
    return false;
  }

  if (isPhoneRequired(locale) && !hasValue(address.phone)) {
    return false;
  }

  const isCompany =
    String(address.category) === String(ADDRESS_SHIPPING_CATEGORY.COMPANY) ||
    String(address.category) === String(ADDRESS_BILLING_CATEGORY.COMPANY);

  if (isCompany && !hasValue(address.company)) {
    return false;
  }

  if (isPickupPoint) {
    const hasPostnummer = hasValue(address.postNumber) || hasValue(address.company);
    const hasStationNumber =
      address.paketstationNr !== undefined ||
      address.servicepointId !== undefined ||
      /^Pakkeboks\s+\S+/i.test(address.street ?? '');

    return hasPostnummer && hasStationNumber;
  }

  return true;
}